import React from "react";
import { Link } from "react-router-dom";

const Error500 = () => {
  const storedCompany = localStorage?.getItem("companyName");
  const storedCompanyName = storedCompany?.toLowerCase()?.replace(/\s+/g, "-");
  return (
    <>
      <div className="error-page" style={{ overflow: "auto" }}>
        {/* Main Wrapper */}
        <div className="main-wrapper">
          <div className="error-box">
            <h1>500</h1>
            <h3>
              <i className="fa-solid fa-triangle-exclamation" /> Oops! Something
              went wrong
            </h3>
            <p className="fst-italic">
              * The page you requested was not found.
            </p>
            <Link to={`/${storedCompanyName}/`} className="btn btn-primary">
              Back to Home
            </Link>
          </div>
        </div>
        {/* /Main Wrapper */}
      </div>
    </>
  );
};

export default Error500;
